import { CircleAlertIcon, CircleCheckIcon, InfoIcon, LoaderCircleIcon, TriangleAlertIcon } from 'lucide-react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils/cn'

/**
 * DS .tr-toast: raised surface, 360px, bottom-right, at most three visible. The theme is passed in
 * by the app providers (components/ui stays free of app state).
 */
function Toaster({ theme = 'system', ...props }: ToasterProps) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      offset={16}
      gap={8}
      visibleToasts={3}
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <CircleAlertIcon className="size-4" />,
        loading: <LoaderCircleIcon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'group/toast flex w-90 items-start gap-2.5 rounded-lg border border-border bg-raised py-3 pr-3 pl-3.5 text-fg shadow-md',
          content: 'flex min-w-0 flex-1 flex-col',
          title: 'text-sm leading-snug font-semibold',
          description: 'mt-0.5 type-caption text-fg-secondary',
          icon: 'mt-px flex shrink-0 items-center text-info-solid',
          success: '[&_[data-icon]]:text-success-solid',
          info: '[&_[data-icon]]:text-info-solid',
          warning: '[&_[data-icon]]:text-warning-solid',
          error: '[&_[data-icon]]:text-danger-solid',
          actionButton: cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'shrink-0 self-center'),
          cancelButton: cn(buttonVariants({ variant: 'ghost', size: 'sm' }), 'shrink-0 self-center'),
          closeButton: 'text-fg-tertiary hover:text-fg',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
